import { authHttp } from '../http'
import * as routes from '../../routes/cte.routes'
import { errorHandler } from '../../../util/error.service'

export async function getCfops() {
  try {
    const response = await authHttp().get(routes.urlCfops)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveCfop({ id, ...body }) {
  try {
    const response = id
      ? await authHttp().put(`${routes.urlCfops}/${id}`, body)
      : await authHttp().post(routes.urlCfops, body)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
